export const ChangeEmailLogin = ({
  email,
  setEmail,
  setClientExists,
  setUserExists,
}) => {
  const handleChangeEmail = () => {
    setEmail('');
    setUserExists(false);
    setClientExists(false);
  };

  return (
    <form className="login-container" onSubmit={handleChangeEmail}>
      <div className="change-email-container relative-container">
        <input
          disabled
          type="email"
          id="email"
          name="email"
          className="change-email-form-input"
          autoComplete="username"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
        <label htmlFor="email" className="contact-form-label">
          Adresse email
        </label>
        <button type="submit" className="login-change-email">
          Modifier
        </button>
      </div>
    </form>
  );
};

/* <div className="password-container relative-container">
      <span className="login-subtitle">
        Votre identifiant: <u>{email}</u>
      </span>
      <button className="login-change-email" onClick={handleChangeEmail}>
        Changer de compte
      </button>
    </div> */
